export interface GetNodeChildsListResponse {
    sessionId: number
    sessionToken: string
    companyName:string
    nodes: ChatBotNode[]
    liveSupportSystemId: number
    liveSupportSystemToken: string
  }
  
  export interface ChatBotNode {
    nodeId: number
    nodeLangId: number
    nodeContent: string
    nodeType: NodeType
  }
  
  export enum NodeType{
    MainNode = 1,
    Content = 2 
  }